import { useState, useEffect } from 'react';
import { useBreakpoint } from '@one-thd/sui-atomic-components';
import { ScreenSize } from '../../../product-results-helpers';

export const useProductsPerRow = (props) => {
  const { channel } = props;
  const matchesScreen = useBreakpoint(ScreenSize.SMALL, { current: true });

  const [productsPerRow, setProductsPerRow] = useState(channel === 'desktop' ? 4 : 1);

  useEffect(() => {
    if (matchesScreen.current === ScreenSize.UNPREFIXED) {
      setProductsPerRow(1);
    } else if ([ScreenSize.SMALL, ScreenSize.MEDIUM].includes(matchesScreen.current)) {
      setProductsPerRow(2);
    } else if (matchesScreen.current === ScreenSize.LARGE) {
      setProductsPerRow(3);
    } else if ([ScreenSize.X_LARGE, ScreenSize.DX_LARGE].includes(matchesScreen.current)) {
      setProductsPerRow(4);
    }
  }, [matchesScreen.current]);

  return [productsPerRow, matchesScreen];
};
